import Dexie from 'dexie'
import { ForemanDB } from '../../types/IndexedDB/ForemanDB'
import { AttachmentInfo } from '../../types/Upload/AttachmentResponse'
import { getTransactionTables, trackEntityUpdate } from '../../utils/MutationSnapshotUtils'
import { WorkItemAttachmentCache } from '../../types/Cache/ForemanCache'

export const getAttachmentFB = async (
	db: ForemanDB,
	attachmentId: number,
): Promise<Blob | null> => {
	const attachment = await db.workItemAttachmentBlobs.get(attachmentId)
	if (attachment) {
		return attachment.blob
	}
	return null
}

export const listAttachmentsFB = async (
	db: ForemanDB,
	itemId: number,
): Promise<AttachmentInfo[]> => {
	const attachments = await db.workItemAttachments
		.filter((attachment) => attachment.workItemId === itemId)
		.toArray()
	return attachments.map((attachment) => ({
		id: attachment.id,
		name: attachment.name,
		updatedAt: attachment.updatedAt,
	}))
}

export const uploadAttachmentsFB = async (
	db: ForemanDB,
	file: File,
	itemId: number,
	newAnnotations: string, // XFDF String
) => {
	db.setNewLogId()
	return await db.transaction(
		'rw',
		getTransactionTables(db, ['workItemAttachmentBlobs', 'workItemAttachments']),
		async () => {
			const tx = Dexie.currentTransaction
			if (!tx) {
				throw new Error('No active transaction found')
			}
			const attachment = (await tx
				.table('workItemAttachments')
				.filter((a) => a.workItemId === itemId && a.name === decodeURIComponent(file.name))
				.first()) as WorkItemAttachmentCache | undefined
			if (!attachment) {
				throw new Error('Attachment not found')
			}

			await tx.table('workItemAttachmentBlobs').put({
				id: attachment.id,
				blob: file,
			})

			await db.annotateAttachment(itemId, attachment.id, newAnnotations)
			
			await tx.table('mutations').put({
				route: `/WorkItems/${itemId}/Attachments`,
				method: 'PATCH',
				body: {},
				title: `Annotated attachment: ${decodeURIComponent(file.name)}`,
				createdAt: new Date(),
				id: db.getLastLogId(),
			})
		},
	)
}
